import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { AREAS } from "@/lib/heat";
import { PrintBar } from "@/components/ResourceNotice";
import { useResourcePrint } from "@/pages/ColoringSheet";

const areaLabel = (k) => AREAS.find((a) => a.key === k)?.label || k;
const year = new Date().getFullYear();

const Topic = ({ t, n }) => (
  <article className="avoid-break border-b border-slate-200 py-5 print:py-3" data-testid={`guide-topic-${t.key}`}>
    <div className="flex flex-wrap items-baseline gap-x-3">
      <h2 className="font-display text-lg font-bold text-slate-900">{n}. {t.title}</h2>
      <span className="text-xs font-semibold uppercase tracking-wider text-[#1F4266]">{t.areas.map(areaLabel).join(" & ")}</span>
    </div>
    <p className="mt-1.5 text-sm leading-relaxed text-slate-700">{t.description}</p>
    <ol className="mt-3 space-y-1.5">
      {t.ratings.map((r) => (
        <li key={r.points} className="grid grid-cols-[2.2rem_1fr] gap-2 text-[13px] leading-snug print:text-[11.5px]">
          <span className="font-mono font-semibold text-[#1F4266]">{r.points}</span>
          <span><span className="font-semibold text-slate-900">{r.name}:</span> <span className="text-slate-700">{r.text}</span></span>
        </li>
      ))}
    </ol>
  </article>
);

export default function CoachingGuide() {
  useResourcePrint();
  const [topics, setTopics] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get("/coaching-guide").then((r) => setTopics(r.data)).catch((e) => setError(errMsg(e)));
  }, []);

  return (
    <div className="resource-doc mx-auto max-w-[8.5in]" data-testid="coaching-guide">
      <PrintBar title="Coaching Guide" />
      <section className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm print-plain">
        <div className="flex items-center gap-3">
          <img src="/flower-logo.png" alt="" className="h-10 w-10" />
          <div>
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500">Minister's Helper · Coaching Guide</div>
            <h1 className="font-display text-2xl font-bold text-slate-900">Topic & Rating Descriptions</h1>
          </div>
        </div>
        <p className="mt-3 text-sm text-slate-600">
          All 25 assessment topics in quiz order, with each topic's description and the full description for each of the five self-ratings (0–4 points).
        </p>
        <p className="mt-2 rounded-lg bg-slate-50 p-3 text-xs text-slate-600" data-testid="guide-notice">
          For Minister's Helper coaches and administrators only. No copying or distribution of this resource is allowed. © {year} Minister's Helper LLC. All rights reserved.
          Questions or permission requests: hello@ministershelper.com
        </p>
        {error && <p className="mt-6 text-sm text-red-600">{error}</p>}
        <div className="mt-2">{topics?.map((t, i) => <Topic key={t.key} t={t} n={i + 1} />)}</div>
      </section>
    </div>
  );
}
